// ABOUTME: Family-wide 3-card row for the parent dashboard's "All Kids" tab — behavior totals,
// ABOUTME: approval queue, and celebration queue. Parent-view + All-Kids-tab-only by insertion point.

import React from 'react';
import { Box } from '@mui/material';
import { EnhancedChildDashboard } from '../../types/api';
import { TodaySeaCard } from './TodaySeaCard';
import { ApprovalQueueCard } from './ApprovalQueueCard';
import { CelebrationQueueCard } from './CelebrationQueueCard';

export interface FamilyStripProps {
  familyId: number;
  familyChildren: EnhancedChildDashboard[];
  onNavigateToChild: (childId: number, choreListId: number) => void;
  onApprovalChanged: () => void;
}

export const FamilyStrip: React.FC<FamilyStripProps> = ({ familyId, familyChildren, onNavigateToChild, onApprovalChanged }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1.4fr 1.2fr' }, gap: 2, mb: 3 }}>
    <TodaySeaCard familyChildren={familyChildren} />
    <ApprovalQueueCard
      familyChildren={familyChildren}
      onNavigateToChild={onNavigateToChild}
      onApproved={onApprovalChanged}
    />
    <CelebrationQueueCard familyId={familyId} familyChildren={familyChildren} />
  </Box>
);
